module.exports = __webpack_public_path__ + "img/margarita.f9915865.jpg";